import { render } from "./customSizeModal.vue?vue&type=template&id=4fb87651&scoped=true"
import script from "./customSizeModal.vue?vue&type=script&lang=js"
export * from "./customSizeModal.vue?vue&type=script&lang=js"

import "./customSizeModal.vue?vue&type=style&index=0&id=4fb87651&scoped=true&lang=css"

import exportComponent from "/home/forge/clients-dev.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb87651"]])

export default __exports__